module.exports = __webpack_public_path__ + "img/flair_vape_2.7adccd17.png";